import { FlowRoute, FlowRouteCategory } from '@eneco/flows/types';

import { FlowContextToonCancellation } from '../context';
import { OverviewStep } from './steps/Overview/Overview';
import { ReasonStep } from './steps/Reason/Reason';

export const initialContext: FlowContextToonCancellation = {};

export const actions = {};

/** The cancellation reason goes along to the thank you page the flow completes to. */
export const completionQueryParams = ({ reason }: FlowContextToonCancellation) => ({ reason });

export const routes: FlowRoute<FlowContextToonCancellation>[] = [
  {
    id: 'REASON',
    path: '/opzegreden/',
    category: FlowRouteCategory.CancelReason,
    component: ReasonStep,
  },
  {
    id: 'SUMMARY',
    path: '/overzicht/',
    category: FlowRouteCategory.Summary,
    component: OverviewStep,
  },
];
